export default __webpack_public_path__ + "static/media/GREZ.6b983f8e.jpeg";